import { AuthCard } from '~/components/routes/login/auth-card'
import { Button } from '~/components/ui/button'
import { signOut } from '~/utils/session-navigation'
import { frenchParisDayOfInstant } from '~/lib/iso-date'
import { MfaEnrollment } from './mfa-enrollment'

/**
 * Enrôlement obligatoire (S1.4b) : la date est passée et le compte, concerné, n'est pas enrôlé. Le
 * serveur ne lui ouvre plus que l'enrôlement et la déconnexion ; le socle affiche cette page à la
 * place de tout le back-office, jusqu'au rechargement qui suit l'activation.
 */
export function MandatoryMfaEnrollment({ requiredFrom }: { requiredFrom: string | null }) {
  return (
    <AuthCard
      title="Activez le double facteur"
      description={
        <>
          Votre compte donne accès à d'autres comptes, aux rôles ou à la RH : le double facteur est
          obligatoire pour l'utiliser
          {requiredFrom ? ` depuis le ${frenchParisDayOfInstant(requiredFrom)}` : ''}. Il vous faut
          une application d'authentification sur votre téléphone.
        </>
      }
      className="max-w-xl"
      contentClassName="flex flex-col gap-6"
    >
      <MfaEnrollment />
      <Button type="button" variant="ghost" className="w-fit" onClick={() => void signOut()}>
        Se déconnecter
      </Button>
    </AuthCard>
  )
}
